module.exports = __webpack_public_path__ + "img/att_not.792cd685.png";